import { FaBuilding, FaShippingFast } from "react-icons/fa";
import { motion } from "framer-motion";

export const InvoiceHeader = ({ data }) => {
  return (
    <motion.div
      className="bg-gradient-to-r from-blue-700 to-blue-900 text-white p-8 rounded-xl shadow-2xl mb-6"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      <div className="flex justify-between items-center">
        <motion.h2
          className="text-3xl font-extrabold tracking-wide"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          {data.invoiceName}
        </motion.h2>
        
        <motion.p
          className="text-md bg-white text-blue-900 px-5 py-1.5 rounded-full font-semibold shadow-md"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          {data?.masterInvoiceNumber}
        </motion.p>
      </div>

      {/* Merged Invoices */}
      <motion.p
        className="mt-1 text-gray-300 text-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
      {data.description}
      </motion.p>
      <motion.p
        className="mt-1 text-gray-300 text-md"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <span className="font-semibold text-white">Merged Invoices:</span> {data.invoiceNumber?.join(", ")}
      </motion.p>
    

      {/* Bill To & Ship To Sections */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
        {/* Bill To */}
        <motion.div
          className="bg-white text-gray-900 p-5 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-[1.03]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.1 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)" }}
        >
          <div className="flex items-center gap-4 mb-4">
            <FaBuilding className="text-blue-600 text-2xl" />
            <h3 className="text-xl font-semibold tracking-wide">Bill To</h3>
          </div>
          <p className="text-gray-600 text-md">{data?.billTo?.num}</p>
          <p className="font-medium text-lg">{data?.billTo?.name}</p>
          <p className="text-gray-600 text-md">{data?.billTo?.city}</p>
          <p className="text-gray-600 text-md">PO BOX: {data?.billTo?.postal}</p>
          <p className="text-gray-600 text-md">{data?.billTo?.street}</p>
          <p className="text-gray-600 text-md">{data?.billTo?.address}</p>
          <p className="text-gray-900 font-semibold text-md mt-2">TRN: {data?.billTo?.trn}</p>
        </motion.div>

        {/* Ship To */}
        <motion.div
          className="bg-white text-gray-900 p-5 rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-[1.03]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.1 }}
          whileHover={{ scale: 1.05, boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)" }}
        >
          <div className="flex items-center gap-4 mb-4">
            <FaShippingFast className="text-green-600 text-2xl" />
            <h3 className="text-xl font-semibold tracking-wide">Ship To</h3>
          </div>
          <p className="text-gray-600 text-md">{data?.shipTo?.num}</p>
          <p className="font-medium text-lg">{data?.shipTo?.name}</p>
          <p className="text-gray-600 text-md">{data?.shipTo?.city}</p>
          <p className="text-gray-600 text-md">PO BOX: {data?.shipTo?.postal}</p>
          <p className="text-gray-600 text-md">{data?.shipTo?.street}</p>
          <p className="text-gray-600 text-md">{data?.shipTo?.address}</p>
          <p className="text-gray-900 font-semibold text-md mt-2">TRN: {data?.billTo?.trn}</p>
        </motion.div>
      </div>
    </motion.div>
  );
};